
const ServiceCard = ({ id, title, description, setSelected }) => {
    return (
        <>
            <button className="w-full sm:w-[300px]">
                <div className="hover:border-sky-400 hover:border-2 border-2 border-transparent rounded-xl flex flex-col items-center py-4 h-full max-h-[300px] bg-white text-white dark:bg-gray-800">
                    <div className="flex px-4 flex-col items-center pb-10">
                        <h5 className="mb-1 text-xl font-medium text-gray-900 dark:text-white">{title}</h5>
                        <span className="p-2 text-sm text-gray-600 dark:text-gray-400">{description}</span>
                    </div>
                </div>
            </button>
        </>
    )
}


export default ServiceCard;